import React from "react";
import { getBoundingClientRect } from "../../../utils/functions";
import { checkTranslation, chooseFontColor, translate } from "../../../utils/useful";


class DiagramComponent extends React.Component {

    state = {
        showDesciption: false,
        node: [

        ]
    }

    componentDidMount() {
        this.setDefaultConfig()
        setTimeout(() => {
            this.setNodesPosition()
        }, 5);

        this.initPosition()
    }

    setDefaultConfig = () => {
        // console.log('thisprops', this.props.data)
    }
    initPosition = () => {

        if (this.props.data?.positionX != null || this.props.data?.positionY != null) {

            this.container.style.left = this.props.data.positionX + 'px'
            this.container.style.top = this.props.data.positionY + 'px'

        }

    }

    // componentDidUpdate(prevProps){
    //     console.log("update")
    //     console.log(this.props.data.nodes)
    //     if(this.props.data.nodes != prevProps.data.nodes ){
    //         console.log("NODES Changed")
    //     }
    // }



    setNodesPosition() {
        // console.log("setNodesPosition")
        let data = this.props.data
        let nodes = data.nodes
        // console.log(this.props.data)
        let newNodes = {}
        let containerPosition = this.container.getBoundingClientRect()
        let contentPosition = this.content?.getBoundingClientRect()
        this.setState({ height: contentPosition.height })
        let componentOffsetX = containerPosition.x + ((containerPosition.width / 2))//*this.props.zoom)//data.positionX
        let componentOffsetY = containerPosition.y + ((containerPosition.height / 2))//*this.props.zoom)//data.positionY


        for (let index = 0; index < Object.values(nodes).length; index++) {
            const node = Object.values(nodes)[index];

            // }
            // Object.values(nodes).forEach(node => {
            let key = node.key
            let newNode = {}
            // console.log("key",key)
            if (this[key]) {
                // console.log(this[key])

                let nodePosition = getBoundingClientRect(this[key])
                // console.log(node.key, nodePosition.x, componentOffsetX, (nodePosition.x - componentOffsetX + (nodePosition.width / 2)) / this.props.zoom)

                newNode = { ...node }

                newNode.relativePosition = {
                    width: nodePosition.width,
                    height: nodePosition.height,
                    x: Math.round((nodePosition.x - componentOffsetX + (nodePosition.width / 2)) / this.props.zoom),
                    y: Math.round((nodePosition.y - componentOffsetY + (nodePosition.height / 2)) / this.props.zoom),

                }

                // console.log(node.key, newNode, node)

                newNodes[key] = newNode
            }
        }
        // console.log("newNodes", newNodes)
        this.props.setNodesPosition(this.props.data?.key, newNodes, { width: contentPosition?.width, height: contentPosition?.height })

    }

    nodeMouseDown(prop, nprop, e) {
        this.props.nodeMouseDown(prop, nprop, e)
    }

    onClick = () => {

        if (this.isOntime) {
            this.isOntime = false
            this.props.openMore(this.props.data.key, true)
        } else {
            // if(this.state.showDesciption){

            // }else{

            // }
            // this.setState({ showDesciption: !this.state.showDesciption }, () => {
            // if (this.state.showDesciption) {
            this.isOntime = true
            setTimeout(() => {
                if (this.isOntime) {
                    this.setState({ showDesciption: !this.state.showDesciption })
                }
                this.isOntime = false
            }, 300);
            //     }
            // })
        }

    }

    onMouseEnter = () => {
        if (this.label && this.labelContainer) {
            this.label.style.width = 'auto'
            this.label.style.overflow = 'visible'
            let labelWidth = this.label.getBoundingClientRect().width
            let mainWidth = this.labelContainer.getBoundingClientRect().width
            let moveWidth = labelWidth - mainWidth
            if (moveWidth > 0) {
                this.label.style.transition = 'left 1.5s'
                this.label.style.left = (-1 * moveWidth) + 'px'
                this.timer = setTimeout(() => {
                    this.onMouseLeave(true)
                }, 3000);
            }
        }
    }

    onMouseLeave = (isFake) => {
        if (this.label) {

            this.label.style.transition = 'left 0.5s'
            this.label.style.left = '0px'
            if (isFake) {
                this.timer = setTimeout(() => {
                    this.onMouseEnter(true)
                }, 2500);
            } else {
                this.label.style.width = '100%'
                this.label.style.overflow = 'hidden'
                if (this.timer) {
                    clearTimeout(this.timer)
                }
            }

        }
    }



    render() {
        let prop = this.props.data
        // console.log('prop.UI?.type', prop.UI?.type)
        let thisFunction = this.props.thisFunction

        let iconInvert = chooseFontColor(prop?.configuration?.color?.text) == '#fff' ? true : false

        return (
            <div className="component flexc flex-column" ref={el => this.container = el} style={{ zIndex: prop.key === this.props.draggingId ? 4 : null, padding: 30, position: 'absolute', transform: 'translate(-50%,-50%)', pointerEvents: 'none' }}>


                <div onMouseEnter={() => this.onMouseEnter()} onMouseLeave={() => this.onMouseLeave()} className="d-flex" style={{ position: 'relative' }}>


                    <div onClick={() => this.onClick()} draggable onTouchEnd={(e) => this.props.dragEnd()} onDragEnd={(e) => this.props.dragEnd()} onTouchMove={(e) => this.props.onDrag(e)} onDrag={(e) => this.props.onDrag(e)} onTouchStart={(e) => this.props.onDragStart(e, prop, 'component')} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: prop.UI?.borderRadius, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                    </div>

                    {/* {prop.UI?.type === 'trigger' && (
                        <>
                            <div draggable onDragEnd={(e) => this.props.dragEnd()} onDrag={(e) => this.props.onDrag(e)} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: 100, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                            </div>

                            <div ref={el => this.content = el} className=" flexcc" style={{ border: '2px solid ' + prop.UI?.bodyColorS, backgroundImage: 'linear-gradient(' + prop.UI?.bodyColorS + ',' + prop.UI?.bodyColorE + ')', borderRadius: 100, padding: 0, width: 120, height: 120, boxShadow: '0px 0px 30px #00000015' }}>

                                <div className="d-flex " >


                                    <div className="flexcc flex-column text-center">
                                        <img className={(prop.UI?.showIcon ? "invert" : '')} src={(prop.UI?.showIcon ?? thisFunction?.icon)} width="34px" />
                                        <p className="white text-smaller mt-2 w-100 text-bold" style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 110 }}>{prop?.title.toUpperCase()}</p>
                                        <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc moreBut rotate-90 p-0">
                                            <img className="invert" draggable={false} src={'/images/more.svg'} height="22px" />
                                        </button>
                                    </div>


                                    <div className="" style={{ position: 'absolute', top: 60, right: 0, transform: 'translateY(-50%)' }} >
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'right') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -8 }}>
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </>
                    )} */}







                    {/* {prop.UI?.type === 'action' && (
                        <>
                            <div draggable onDragEnd={(e) => this.props.dragEnd()} onDrag={(e) => this.props.onDrag(e)} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: 100, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                            </div>

                            <div className=" flexcc" style={{ border: '2px solid ' + prop.UI?.bodyColorS, backgroundImage: 'linear-gradient(' + prop.UI?.bodyColorS + ',' + prop.UI?.bodyColorE + ')', borderRadius: 100, padding: 0, width: 120, height: 120, boxShadow: '0px 0px 30px #00000015' }}>

                                <div className="d-flex " >


                                    <div className="flexcc flex-column text-center">
                                        <img className={(prop.UI?.showIcon ? "invert" : '')} src={(prop.UI?.showIcon ?? thisFunction?.icon)} width="34px" />
                                        <p className="white text-smaller mt-2 w-100 text-bold" style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 110 }}>{prop?.title.toUpperCase()}</p>
                                        <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc moreBut rotate-90 p-0">
                                            <img className="invert" draggable={false} src={'/images/more.svg'} height="22px" />
                                        </button>
                                    </div>


                                    <div className="" style={{ position: 'absolute', top: 60, left: 0, transform: 'translateY(-50%)' }} >
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'left') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginLeft: -8 }}>
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </>
                    )} */}

                    {prop.UI?.type === 'stage' && (
                        <>
                            {/* <div draggable onDragEnd={(e) => this.props.dragEnd()} onDrag={(e) => this.props.onDrag(e)} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: prop.UI?.borderRadius, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                            </div> */}
                            {/* <svg>
                                <path style="stroke-linejoin: round; opacity: 1;" fill="none" stroke="#4c9aff" d="M188.59998474121096,22L188.59998474121096,22S188.59998474121096,22,188.59998474121096,22L188.59998474121096,102.4359096288681S188.59998474121096,104.4359096288681,190.59998474121096,104.4359096288681L401.421484375,104.4359096288681S403.421484375,104.4359096288681,403.421484375,106.4359096288681L403.421484375,186.8718192577362S403.421484375,186.8718192577362,403.421484375,186.8718192577362" stroke-linejoin="round" stroke-width="2" opacity="1"></path>
                            </svg> */}
                            {/* <div className=" flexcc" style={{ backgroundColor: prop.UI?.bodyColor, borderRadius: 100, padding: 0, width: 130, height: 130, boxShadow: '0px 0px 30px #00000015' }}> */}
                            <div ref={el => this.content = el} className=" flexcc " style={{ position: 'relative', width: 95 }}>

                                <div className="d-flex w-100" style={{}} >
                                    <div className="w-100  flexcc flex-column">
                                        <div className="pld-2 prd-2 flexcc flex-column pb-2">
                                            <div className="  mt-1  text-center " style={{ border: prop.UI?.border, background: prop.configuration?.color?.background ?? '#fff', color: prop.configuration?.color?.text ?? '#000', borderRadius: 8, width: 95, height: 45, boxShadow: '0px 0px 20px #00000010' }}>

                                                {/* <div className="br-6 px-2 py-1 br-20" style={{}}>
                                                    <div className="invert  flexcc">
                                                        <img className={" " + (prop.UI?.icon ? "" : 'invert')} src={(prop.UI?.icon ?? thisFunction?.icon)} height={'20px'} />
                                                    </div>
                                                </div> */}
                                                {/* {console.log(prop.configuration)} */}
                                                <div className="w-100">
                                                    <div className="w-100 flexcb px-2 " style={{ backgroundColor: '#10101000', borderRadius: '8px 8px 0px 0px', paddingTop: 5, paddingBottom: 0 }}>
                                                        <div className="flexc">
                                                            <div className="invert  flexcc">
                                                                <img className={" " + (iconInvert ? "invert" : '')} src={(prop.UI?.icon ?? thisFunction?.icon)} height={'12px'} />
                                                            </div>
                                                            <p className="text-smallest  mld-1 text-semibold">{translate("Stage")}</p>

                                                        </div>
                                                        <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc moreBut rotate-90  p-0 opacity-5"  >
                                                            <img className={"" + (!iconInvert ? 'invert' : '')} draggable={false} src={'/images/more.svg'} height="12px" />
                                                        </button>
                                                    </div>

                                                    <div className=" text-start flexcc flex-column" style={{ marginTop: 2 }}>
                                                        <div ref={el => this.labelContainer = el} className="w-100 " style={{ maxWidth: 70, overflow: 'hidden', position: 'relative' }}>
                                                            <p className="text-bold" style={{ color: 'transparent', whiteSpace: 'nowrap', fontSize: 12 }}>{checkTranslation(prop?.title)}</p>
                                                            <p ref={el => this.label = el} className="  text-bold" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap', fontSize: 12, position: 'absolute', left: 0, top: 0, transition: 'left 2s' }}>{checkTranslation(prop?.title)}</p>
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* <div className="position-absolute br-30 flexcc" style={{ top:35,right:5,height:20,width:20, background:"#00000060",boxShadow:'0px 0px 10px #10101010' }}  >

                                                    <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc moreBut rotate-90  p-0"  >
                                                        <img className="invert" draggable={false} src={'/images/more.svg'} height="12px" />
                                                    </button>

                                                </div> */}
                                            </div>


                                        </div>
                                        {/* <div className="w-100 pb-2  br-6 flexcc flex-column px-2 pt-2 " style={{ background: '#f8f8f8' }}>
                                            <p className="text-smallest color-gray-2 text-center">3 people have access. 2 Views are included</p>
                                            <div className="flexc justify-content-end px-1 mt-2">
                                                {[1, 1, 1].map((image, i) => {
                                                    return (
                                                        <div>
                                                            <img src={'/assets/profile-def.png'} height={16} width={16} style={{ borderRadius: 20 }} />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div> */}
                                    </div>


                                    <div className="" style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }} >
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'right') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -5 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <div onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}

                                        </div>
                                    </div>



                                    <div className="" style={{ position: 'absolute', top: "50%", left: 0, transform: 'translateY(-50%)' }} >
                                        <div >

                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'left') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginLeft: -5 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <div onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </>
                    )}


                    {prop.UI?.type === 'operator' && (
                        <>
                            {/* <div draggable onDragEnd={(e) => this.props.dragEnd()} onDrag={(e) => this.props.onDrag(e)} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: prop.UI?.borderRadius, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                            </div> */}
                            {/* <svg>
                                <path style="stroke-linejoin: round; opacity: 1;" fill="none" stroke="#4c9aff" d="M188.59998474121096,22L188.59998474121096,22S188.59998474121096,22,188.59998474121096,22L188.59998474121096,102.4359096288681S188.59998474121096,104.4359096288681,190.59998474121096,104.4359096288681L401.421484375,104.4359096288681S403.421484375,104.4359096288681,403.421484375,106.4359096288681L403.421484375,186.8718192577362S403.421484375,186.8718192577362,403.421484375,186.8718192577362" stroke-linejoin="round" stroke-width="2" opacity="1"></path>
                            </svg> */}
                            {/* <div className=" flexcc" style={{ backgroundColor: prop.UI?.bodyColor, borderRadius: 100, padding: 0, width: 130, height: 130, boxShadow: '0px 0px 30px #00000015' }}> */}
                            <div ref={el => this.content = el} className=" flexcc " style={{ position: 'relative', width: 50 }}>

                                <div className="d-flex w-100" style={{}} >
                                    <div className="w-100  flexcc flex-column">
                                        <div className="pld-2 prd-2 flexcc flex-column pb-2">
                                            <div className="flexcc flex-column   text-center " style={{ border: '1px solid #e0e0e0', backgroundImage: 'linear-gradient(' + prop.UI?.bodyColorS + ',' + prop.UI?.bodyColorE + ')', borderRadius: 8, width: 50, height: 50, boxShadow: '0px 0px 20px #00000010' }}>

                                                <div className="br-6 px-2 py-0 br-20" style={{}}>
                                                    <div className="invert  flexcc">
                                                        <img className={" " + (prop.UI?.icon ? "" : 'invert')} src={(prop.UI?.icon ?? thisFunction?.icon)} height={'26px'} />
                                                    </div>
                                                </div>

                                                <div className="" style={{ opacity: '0.5' }}  >

                                                    <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc moreBut rotate-90  p-0"  >
                                                        <img className=" " draggable={false} src={'/images/more.svg'} height="12px" />
                                                    </button>

                                                </div>
                                            </div>

                                            <div className=" text-center flexcc flex-column position-absolute " style={{ top: 54 }}>
                                                <div ref={el => this.labelContainer = el} className="mt-1 " style={{ width: 85, position: 'relative' }}>
                                                    {/* <p className="text-bold" style={{ color: 'transparent', whiteSpace: 'nowrap', fontSize: 12 }}>{checkTranslation(prop?.title)}</p> */}
                                                    <p ref={el => this.label = el} className="text-bold" style={{ color: prop.UI?.textColor, width: '100%', fontSize: 11, left: 0, top: 0, transition: 'left 2s' }}>{checkTranslation(prop?.title)}</p>
                                                </div>
                                                {/* <div>
                                                    <p className="text-smallest opacity-5">3 days</p>
                                                </div> */}
                                            </div>
                                        </div>
                                        {/* <div className="w-100 pb-2  br-6 flexcc flex-column px-2 pt-2 " style={{ background: '#f8f8f8' }}>
                                            <p className="text-smallest color-gray-2 text-center">3 people have access. 2 Views are included</p>
                                            <div className="flexc justify-content-end px-1 mt-2">
                                                {[1, 1, 1].map((image, i) => {
                                                    return (
                                                        <div>
                                                            <img src={'/assets/profile-def.png'} height={16} width={16} style={{ borderRadius: 20 }} />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div> */}
                                    </div>


                                    <div className="" style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }} >
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'right') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -7 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <div onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}

                                        </div>
                                    </div>



                                    <div className="" style={{ position: 'absolute', top: "50%", left: 0, transform: 'translateY(-50%)' }} >
                                        <div >

                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'left') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginLeft: -7 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <div onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </>
                    )}




                    {(prop.UI?.type === 'trigger' || prop.UI?.type === 'action') && (
                        <>

                            <div ref={el => this.content = el} className=" flexcc " style={{ position: 'relative', width: 50 }}>

                                <div className="d-flex w-100" style={{}} >
                                    <div className="w-100  flexcc flex-column">
                                        <div className="pld-2 prd-2 flexcc flex-column pb-2">
                                            <div className="flexcc flex-column   text-center " style={{ border: prop.UI?.type === 'action' ? "1px solid #007aff" : '1px solid #ff0055', backgroundImage: 'linear-gradient(' + prop.UI?.bodyColorS + ',' + prop.UI?.bodyColorE + ')', borderRadius: 40, width: 58, height: 58, boxShadow: '0px 0px 20px #00000010' }}>

                                                <div className="br-6 px-2 py-0 br-20" style={{}}>
                                                    <div className="invert  flexcc">
                                                        <img className={" " + (!prop.UI?.invertIcon ? "invert" : '')} src={(prop.UI?.icon ?? thisFunction?.icon)} height={'24px'} />
                                                    </div>
                                                </div>

                                                <div className="" style={{ opacity: '1', transform: 'translate(0px,3px)' }}  >

                                                    <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc moreBut rotate-90  p-0"  >
                                                        <img className={" " + (prop.UI?.invertIcon ? "invert" : '')} draggable={false} src={'/images/more.svg'} height="12px" />
                                                    </button>

                                                </div>
                                            </div>

                                            <div className=" text-center flexcc flex-column position-absolute " style={{ top: 58 }}>
                                                <div ref={el => this.labelContainer = el} className="mt-1 " style={{ width: 75, position: 'relative' }}>
                                                    {/* <p className="text-bold" style={{ color: 'transparent', whiteSpace: 'nowrap', fontSize: 12 }}>{checkTranslation(prop?.title)}</p> */}
                                                    <p ref={el => this.label = el} className="text-bold" style={{ color: prop.UI?.textColor, width: '100%', fontSize: 10, left: 0, top: 0, transition: 'left 2s' }}>{checkTranslation(prop?.title)}</p>
                                                </div>
                                                {/* <div>
                                                    <p className="text-smallest opacity-5">3 days</p>
                                                </div> */}
                                            </div>
                                        </div>
                                        {/* <div className="w-100 pb-2  br-6 flexcc flex-column px-2 pt-2 " style={{ background: '#f8f8f8' }}>
                                            <p className="text-smallest color-gray-2 text-center">3 people have access. 2 Views are included</p>
                                            <div className="flexc justify-content-end px-1 mt-2">
                                                {[1, 1, 1].map((image, i) => {
                                                    return (
                                                        <div>
                                                            <img src={'/assets/profile-def.png'} height={16} width={16} style={{ borderRadius: 20 }} />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div> */}
                                    </div>


                                    <div className="" style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }} >
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'right') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -10 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <div onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}

                                        </div>
                                    </div>



                                    <div className="" style={{ position: 'absolute', top: "50%", left: 0, transform: 'translateY(-50%)' }} >
                                        <div >

                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'left') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginLeft: -10 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <div onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </>
                    )}





                    {prop.UI?.type === 'condition' && (
                        <>
                            {/* <div draggable onDragEnd={(e) => this.props.dragEnd()} onDrag={(e) => this.props.onDrag(e)} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: prop.UI?.borderRadius, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                            </div> */}
                            <div ref={el => this.content = el} className="pb-1 " style={{ position: 'relative', backgroundImage: 'linear-gradient(' + prop.UI?.bodyColorS + ',' + prop.UI?.bodyColorE + ')', border: '0px solid ' + thisFunction?.UI?.bodyColorS, borderRadius: prop.UI?.borderRadius, padding: 0, width: prop.UI?.width, boxShadow: '0px 0px 30px #00000015' }}>
                                <div className="w-100 flexcb pt-1 mt-0 px-2" style={{ backgroundColor: thisFunction?.UI?.headerColor, borderRadius: '10px 10px 0px 0px' }}>
                                    <div className="flexcc " style={{ maxWidth: prop.UI?.width - 37 }}>
                                        <img className={(prop.UI?.inverImage ? "invert" : '')} src={(prop.UI?.icon ?? thisFunction?.icon)} width="14px" />
                                        {/* <p className="white text-smaller mx-1 text-bold ">{prop?.title?.toUpperCase()}</p> */}
                                        <div ref={el => this.labelContainer = el} className="w-100 mx-1" style={{ overflow: 'hidden', position: 'relative' }}>
                                            <p className=" text-smallest  text-bold" style={{ color: 'transparent', whiteSpace: 'nowrap' }}>{checkTranslation(prop?.title)}</p>
                                            <p ref={el => this.label = el} className=" text-smallest   text-semibold" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap', position: 'absolute', left: 0, top: 0, transition: 'left 2s' }}>{checkTranslation(prop?.title)}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <button onClick={() => this.props.openMore(this.props.data.key)} className="flexcc moreBut px-0 py-1 " style={{}}>
                                            <img className=" rotate-90" draggable={false} src={'/images/more.svg'} height="12px" />
                                        </button>
                                    </div>
                                    {/* <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc pld-1 prd-0 moreBut" style={{position:'absolute',top:10,left:10}}>
                                        <img draggable={false} className="invert" src={'/images/more.svg'} height="14px" />
                                    </button> */}
                                </div>




                                <div className="d-flex mt-0" style={{ justifyContent: 'space-between' }}>


                                    <div className="" style={{ position: 'relative' }}>
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'left') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-start', marginLeft: -8 }}>
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>
                                                            <p className=" text-semibold mx-1 " style={{ fontSize: 11 }}>{checkTranslation(nprop.label)}</p>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>


                                    <div className="" style={{ position: 'relative' }} >

                                        <div >

                                            {Object.values(prop.nodes)?.sort((a, b) => a.sort > b.sort ? 1 : -1)?.map((nprop, index) => {
                                                if (nprop.position == 'right') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -8 }}>
                                                            <p className=" text-semibold mx-1 " style={{ fontSize: 11 }}>{checkTranslation(nprop.label)}</p>
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>


                                    </div>
                                </div>


                                {/* <div className="flexcc mb-1">
                                    <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc moreBut  " style={{ backgroundColor: '#ffffff20', borderRadius: 20, padding: '2px 10px' }}>
                                        <img className="invert rotate-90" draggable={false} src={'/images/more.svg'} height="22px" />
                                    </button>
                                </div> */}


                                {/* <div className="px-2 mt-1">
                                    <p className="white" style={{ opacity: 0.8, fontSize: 11 }}>This is the description of this component</p>
                                </div> */}

                                {/* <div className="px-2 pt-0 pb-1">
                            <p className="text-smaller mt-1 text-bold" style={{opacity:0.5}}>PERMISSIONS</p>
                            <p className="text-smaller" style={{opacity:0.5}}>User admin marketing</p>
                        </div> */}
                            </div>
                        </>
                    )}





                    {prop.UI?.type === 'circle' && (
                        <>
                            {/* <div draggable onDragEnd={(e) => this.props.dragEnd()} onDrag={(e) => this.props.onDrag(e)} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: prop.UI?.borderRadius, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                            </div> */}

                            {/* <div className=" flexcc" style={{ backgroundColor: prop.UI?.bodyColor, borderRadius: 100, padding: 0, width: 130, height: 130, boxShadow: '0px 0px 30px #00000015' }}> */}
                            <div ref={el => this.content = el} className=" flexcc" style={{ position: 'relative', border: '2px solid ' + prop.UI?.bodyColorS, backgroundImage: 'linear-gradient(' + prop.UI?.bodyColorS + ',' + prop.UI?.bodyColorE + ')', borderRadius: prop.UI?.borderRadius, padding: 0, width: prop.UI?.width, height: prop.UI?.width, boxShadow: '0px 0px 30px #00000015' }}>

                                <div className="d-flex " style={{ height: '78%' }} >

                                    <div className="d-flex flex-column text-center h-100" style={{ alignItems: 'center', }}>
                                        <div className="flexcc">
                                            <img className={"mt-1 " + (prop.UI?.inverImage ? "invert" : '')} src={(prop.UI?.icon ?? thisFunction?.icon)} height={prop.UI?.width / 4 + 'px'} />
                                        </div>
                                        <div className="flexcc flex-column mt-1" >
                                            <div ref={el => this.labelContainer = el} className="w-100" style={{ maxWidth: prop.UI?.width - 16, overflow: 'hidden', position: 'relative' }}>
                                                <p className="  text-bold" style={{ color: 'transparent', whiteSpace: 'nowrap', fontSize: 11 }}>{checkTranslation(prop?.title)}</p>
                                                <p ref={el => this.label = el} className="white  text-bold" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap', fontSize: 11, position: 'absolute', left: 0, top: 0, transition: 'left 2s' }}>{checkTranslation(prop?.title)}</p>
                                            </div>
                                            <button onClick={() => this.props.openMore(this.props.data.key)} className="flexcc moreBut  p-0" style={{ marginTop: -2 }}>
                                                <img className="invert rotate-90" draggable={false} src={'/images/more.svg'} width="18px" />
                                            </button>

                                        </div>
                                    </div>


                                    <div className="" style={{ position: 'absolute', top: prop.UI?.width / 2, right: 0, transform: 'translateY(-50%)' }} >
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'right') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -8 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}

                                        </div>
                                    </div>



                                    <div className="" style={{ position: 'absolute', top: prop.UI?.width / 2, left: 0, transform: 'translateY(-50%)' }} >
                                        <div >

                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'left') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginLeft: -8 }}>
                                                            {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </>
                    )}





                    {!prop.UI?.type && (
                        <>
                            <div draggable onTouchEnd={(e) => this.props.dragEnd()} onDragEnd={(e) => this.props.dragEnd()} onTouchMove={(e) => this.props.onDrag(e)} onDrag={(e) => this.props.onDrag(e)} onTouchStart={(e) => this.props.onDragStart(e, prop, 'component')} onDragStart={(e) => this.props.onDragStart(e, prop, 'component')} style={{ pointerEvents: 'all', borderRadius: 100, position: 'absolute', top: 0, left: 0, cursor: 'move', padding: 0, width: '100%', height: '100%' }}>
                            </div>
                            <div ref={el => this.content = el} className="pb-3 " style={{ backgroundColor: thisFunction?.bodyColor, border: '1px solid ' + thisFunction?.headerColor + '20', borderRadius: 6, padding: 0, width: 180, boxShadow: '0px 0px 30px #00000015' }}>
                                <div className="w-100 flexcb p-2" style={{ backgroundColor: thisFunction?.headerColor, borderRadius: '5px 5px 0px 0px' }}>
                                    <div className="flexc">
                                        <img src={thisFunction?.icon} width="16px" />
                                        <p className="white text-smaller mx-1">{checkTranslation(prop?.title)}</p>
                                    </div>
                                    <button onClick={() => this.props.openMore(this.props.data.key)} className="m-0 flexcc pld-1 prd-0 moreBut">
                                        <img draggable={false} className="invert" src={'/images/more.svg'} height="14px" />
                                    </button>
                                </div>




                                <div className="d-flex mt-2" style={{ justifyContent: 'space-between' }}>


                                    <div className="" style={{ position: 'relative' }}>
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'left') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-start', marginLeft: -8 }}>
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>
                                                            <p className="text-smallest mx-1">{checkTranslation(nprop.label)}</p>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>


                                    <div className="" style={{ position: 'relative' }} >
                                        <div >
                                            {Object.values(prop.nodes)?.map((nprop, index) => {
                                                if (nprop.position == 'right') {
                                                    return (
                                                        <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -8 }}>
                                                            <p className="text-smallest mx-1">{checkTranslation(nprop.label)}</p>
                                                            <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
                                                                <button onMouseDown={(e) => this.nodeMouseDown(prop, nprop, e)} className="contactBut">
                                                                </button>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>



                                </div>


                                {/* <div className="px-2 mt-1">
                                    <p className="" style={{ opacity: 0.5, fontSize: 11 }}>This is the description of this component</p>
                                </div> */}

                                {/* <div className="px-2 pt-0 pb-1">
                            <p className="text-smaller mt-1 text-bold" style={{opacity:0.5}}>PERMISSIONS</p>
                            <p className="text-smaller" style={{opacity:0.5}}>User admin marketing</p>
                        </div> */}
                            </div>
                        </>
                    )}


                </div>

                {prop?.configuration?.description && (
                    <div className="px-2 w-100  flexcc text-center " style={{ position: 'absolute', top: this.state.height + 36, pointerEvents: 'none', maxWidth: prop.UI?.width ? prop.UI?.width + 30 : 140, transition: 'all 0.3s', opacity: this.state.showDesciption ? 1 : 0 }}>
                        <div className="blur-back" style={{ backgroundColor: '#001020aa', borderRadius: 6, padding: '5px 5px' }}>
                            <p className="white" style={{ opacity: 0.8, fontSize: 11, whiteSpace: 'pre-wrap' }}>{checkTranslation(prop?.configuration?.description)}</p>
                        </div>
                    </div>
                )}



            </div>
        )
    }
}



export default DiagramComponent;
